const REFRESH_RATE_MINUMUM = 1000;
export function isQueryWithRequestSettings(query) {
    return 'requestSettings' in query;
}
export function getValidRefreshRate(refreshRate) {
    try {
        if (refreshRate && refreshRate < 1000) {
            throw new Error('Refresh rate has minimum value of 1000 miliseconds. Setting rerfesh rate to 1 second.');
        }
        return refreshRate;
    }
    catch (error) {
        console.error(error);
        return REFRESH_RATE_MINUMUM; // reasign to minumum value if under 1000 ms
    }
}
